var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { CardStatus } from './CardStatus';
var Container = styled.ul.withConfig({ displayName: "Container", componentId: "sc-17kta5i" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  gap: 6px;\n  margin: 0;\n"], ["\n  display: flex;\n  gap: 6px;\n  margin: 0;\n"])));
var CardsStatus = function (_a) {
    var items = _a.items, rest = __rest(_a, ["items"]);
    return (_jsx(Container, __assign({}, rest, { children: items.map(function (item, index) { return (_jsx(CardStatus, { item: item }, index)); }) }), void 0));
};
export { CardsStatus };
var templateObject_1;
